import React from 'react';
import moment from 'moment';
import {
  TBody,
  Td,
  Th,
  Tr,
} from 'components/UIKit/Table';
import Column from 'components/UIKit/Flex/Column';
import Header from 'components/UIKit/Details/Content/Header';
import VerticalTable from './VerticalTable';

export default function DetailsSummary({
  dictionaryNode,
  entity: item,
}) {
  const uniqueKeys = dictionaryNode.uniqueKeys.reduce((acc, val) => ([...acc, ...val]), []);
  const notNullOrNegativeOne = x => item[x[0]] && item[x[0]] !== -1;
  const projectRow = x => ({ [x[0]]: item[x[0]], isDate: x[1][1] });
  const isDate = def => !!(def && def.oneOf && def.oneOf.some(x => x.format === 'date-time'));

  const keys = new Map([
    ...Object.keys(dictionaryNode.properties).filter(x => x !== 'type').map(x => [x, ['properties', isDate(dictionaryNode.properties[x])]]),
    ...(dictionaryNode.required || []).map(x => [x, ['required', isDate(dictionaryNode.properties[x])]]),
    ...dictionaryNode.systemProperties.map(x => [x, ['systemProperties', isDate(dictionaryNode.properties[x])]]),
    ...uniqueKeys.map(x => [x, ['uniqueKeys', isDate(dictionaryNode.properties[x])]]),
  ]);

  const summary = [
    ...[...keys].filter(x => x[1][0] === 'uniqueKeys').filter(notNullOrNegativeOne).map(projectRow),
    ...[...keys].filter(x => x[1][0] === 'systemProperties').filter(notNullOrNegativeOne).map(projectRow),
  ];

  const details = [
    ...[...keys].filter(x => x[1][0] === 'required').filter(notNullOrNegativeOne).map(projectRow),
    ...[...keys].filter(x => x[1][0] === 'properties').filter(notNullOrNegativeOne).map(projectRow),
  ];

  return (
    <Column>
      <Header style={{ color: '#666' }}>SUMMARY</Header>
      <VerticalTable>
        <TBody>
          <Tr>
            <Th>Type</Th>
            <Td style={{ textTransform: 'capitalize' }}>{item.type}</Td>
          </Tr>

          <Tr>
            <Th>UUID</Th>
            <Td>{item.id}</Td>
          </Tr>

          {summary.map(item => Object.keys(item)
            .filter(key => key !== 'isDate' && key !== 'id' && (
              typeof item[key] === 'string'
              || typeof item[key] === 'number'
              || Array.isArray(item[key])
            ))
            .map(key => (
              <Tr key={key}>
                <Th style={{ textTransform: 'capitalize' }}>{key.replace(/_/g, ' ')}</Th>
                <Td>
                  {keys.get(key)[1]
                    ? moment(item[key]).format('ll')
                  : Array.isArray(item[key])
                    ? (
                      <ul
                        style={{
                          fontWeight: 300,
                          paddingLeft: '20px',
                        }}
                        >
                        {item[key].map(datum => (
                          <li key={`${key}-${datum}`}>{datum}</li>
                        ))}
                      </ul>
                    )
                  : item[key]}
                </Td>
              </Tr>
            )))}
        </TBody>
      </VerticalTable>

      {details.length > 0 && [
        <Header key="DetailsHeader" style={{ color: '#666' }}>DETAILS</Header>,
        <VerticalTable key="DetailsVerticalTable">
          <TBody>
            {details.map(item => Object.keys(item)
              .filter(key => key !== 'isDate' && key !== 'id' && (
                typeof item[key] === 'string'
                || typeof item[key] === 'number'
                || typeof item[key] === 'boolean'
                || Array.isArray(item[key])
              ))
              .map(key => (
                <Tr key={key}>
                  <Th style={{ textTransform: 'capitalize' }}>{key.replace(/_/g, ' ')}</Th>
                  <Td>
                    {keys.get(key)[1]
                      ? moment(item[key]).format('ll')
                    : Array.isArray(item[key])
                      ? (
                        <ul
                          style={{
                            fontWeight: 300,
                            paddingLeft: '20px',
                          }}
                          >
                          {item[key].map(datum => (
                            <li key={`${key}-${datum}`}>{datum}</li>
                          ))}
                        </ul>
                      )
                    : `${item[key]}`}
                  </Td>
                </Tr>
              )))}
          </TBody>
        </VerticalTable>,
      ]}
    </Column>
  );
}
